<div *ngIf="question">
<a *ngIf="!readOnly && !mobile && question.nextId!=null && this.restService.getQuestionIds()[this.restService.maxQuestions-1] != question.id"
   [routerLink]="examMode ? ['/question-pool-exam/', ''+question.nextId, '0'] : ['/question-pool-study/', ''+question.nextId]"
   class="btn btn-sm btn-outline-dark float-end ms-2" title="Next question">
  >>
</a>
<a *ngIf="!readOnly && !mobile && question.prevId!=null"
   [routerLink]="examMode ? ['/question-pool-exam/', ''+question.prevId, '0'] : ['/question-pool-study/', ''+question.prevId]"
   class="btn btn-sm btn-outline-dark float-end" title="Previous question">
  <<
</a>
<!-- text-center  -->
<h6 class="the-question lh-base mb-4" [ngClass]="{'the-question-img': question.title != null && question.title!.indexOf('<img')>0 && questionImageUrlsForDisplay().length === 0}">
  <!-- QUESTION TIP -->
  <!-- <button title="Answer tip" class="btn py-0 px-1 mt-0 border-0 bg-warning bg-opacity-50"
          *ngIf="question.tip != null"
          data-bs-toggle="collapse"
          aria-expanded="false"
          data-bs-target="#tip_question"
          aria-controls="tip_question">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-left-text py-0" viewBox="0 0 16 16">
      <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
      <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6m0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
    </svg>
  </button> -->
  <!-- QUESTION -->
  <div style="padding-top: 20px">
  <span class="image-container" [innerHTML]="getQuestionTitleForDisplay()"></span>
</div>
</h6>

<!-- Question images: stacked vertically below stem text -->
<div *ngIf="questionImageUrlsForDisplay().length > 0" class="question-figures mb-5">
  <div *ngFor="let imgUrl of questionImageUrlsForDisplay()" class="question-figure mb-4">
    <img [src]="imgUrl"
        (click)="openModal(imgUrl)"
        alt="" class="responsive-image clickable-image" />
  </div>
</div>
<!-- Overlay: original size on click, click outside to close -->
<div *ngIf="isModalOpen && imageOverlayUrl" class="image-overlay" (click)="closeModal()">
  <img [src]="imageOverlayUrl" alt="Full size" class="image-overlay-img" (click)="$event.stopPropagation()" />
</div>

<div class="question-container" #swipeArea>
  
  <form *ngIf="question" (ngSubmit)="onSubmit()" [formGroup]="questionDetailForm">
    <div formArrayName="answers">
      <div *ngFor="let control of answersArray.controls; let i = index">
        <div class="mb-3 form-check">
          <input type="checkbox" class="checkbox-button"
                 [id]="'answer_' + i"
                 [formControlName]="i"
                 (change)="onChange($event)"
          >
          <label
            [ngClass]="{
              'right': (!question.canAnswer || isSubmitted) && (question.answers[i].isCorrect && control.value || question.answers[i].isCorrect && !question.correctAnswer) && !examMode,
              'wrong': (!question.canAnswer || isSubmitted) && !question.answers[i].isCorrect && control.value && !examMode,
              'disable-hover': isSubmitted && !control.value,
              'disable-hover-selected': isSubmitted && control.value,
              'selected-exam': examMode && control.value
            }"
            [for]="'answer_' + i"
            [innerHTML]="question.answers[i].label">
          </label>
        </div>
      </div>
    </div>
  </form>
</div>
</div>